/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Altibase RDS API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  AltiSqlDetailResponse,
  ApiResponseAltibaseParameterDetailResponse,
  ApiResponseSessionDetailV7Response,
  GetV7AltibaseActiveSessionListParams,
  GetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdParams,
  GetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdParams,
  GetV7AltibaseLockParams,
  GetV7AltibaseMemoryByTableParams,
  GetV7AltibaseParameterDetailByInstanceIdAndParameterNameParams,
  GetV7AltibaseReplicationInfoByInstanceIdParams,
  GetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidParams,
  GetV7AltibaseSqlByIntervalParams,
  GetV7AltibaseSqlListByIntervalParams,
  GetV7AltibaseSqlListParams,
  LockListV7Response,
  MemoryModuleResponse,
  MemoryTableV7Response,
  MultiSessionKillResponse,
  MultiSessionTargetForm,
  ParameterListV7Response,
  PostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdParams,
  PostV7AltibaseSessionsKillSessionByInstanceIdParams,
  ReplicationInfoV7Response,
  ReplicationV7Response,
  SessionListV7Response,
  SqlIntervalV7Response,
  SqlListByIntervalV7Response,
  SqlListV7Response,
  SqlPlanOptionRequest,
  SqlPlanV7Response,
  SqlTextBySqlIdV7Response,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Altibase Active Session 조회
 */
export const getV7AltibaseActiveSessionList = (
  params: MaybeRef<GetV7AltibaseActiveSessionListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SessionListV7Response>(
    { url: `/api/v7/altibase/active-session-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7AltibaseActiveSessionListQueryKey = (
  params?: MaybeRef<GetV7AltibaseActiveSessionListParams>,
) => {
  return ['api', 'v7', 'altibase', 'active-session-list', ...(params ? [params] : [])] as const;
};

export const getGetV7AltibaseActiveSessionListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseActiveSessionList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseActiveSessionListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseActiveSessionList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseActiveSessionListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7AltibaseActiveSessionList>>> = ({
    signal,
  }) => getV7AltibaseActiveSessionList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseActiveSessionList>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseActiveSessionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseActiveSessionList>>
>;
export type GetV7AltibaseActiveSessionListQueryError = ErrorType<unknown>;

/**
 * @summary Altibase Active Session 조회
 */

export function useGetV7AltibaseActiveSessionList<
  TData = Awaited<ReturnType<typeof getV7AltibaseActiveSessionList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseActiveSessionListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseActiveSessionList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseActiveSessionListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 알티베이스의 경우 PLAN을 타겟DB에서 직접 조회합니다, execute {} 와 같은 형태의 프로시저 호출에 대해서는 플랜을 제공하지 않습니다.
 * @summary 알티베이스 - Plan 조회
 */
export const postV7AltibaseInstanceSqlPlanByInstanceIdAndSqlId = (
  instanceId: MaybeRef<string>,
  sqlId: MaybeRef<string>,
  sqlPlanOptionRequest: MaybeRef<SqlPlanOptionRequest>,
  params: MaybeRef<PostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  sqlId = unref(sqlId);
  sqlPlanOptionRequest = unref(sqlPlanOptionRequest);
  params = unref(params);

  return customAxiosInstance<SqlPlanV7Response>(
    {
      url: `/api/v7/altibase/instance/${instanceId}/sql/${sqlId}/plan`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sqlPlanOptionRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7AltibaseInstanceSqlPlanByInstanceIdAndSqlId>>,
    TError,
    {
      instanceId: string;
      sqlId: string;
      data: BodyType<SqlPlanOptionRequest>;
      params: PostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7AltibaseInstanceSqlPlanByInstanceIdAndSqlId>>,
  TError,
  {
    instanceId: string;
    sqlId: string;
    data: BodyType<SqlPlanOptionRequest>;
    params: PostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdParams;
  },
  TContext
> => {
  const mutationKey = ['postV7AltibaseInstanceSqlPlanByInstanceIdAndSqlId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7AltibaseInstanceSqlPlanByInstanceIdAndSqlId>>,
    {
      instanceId: string;
      sqlId: string;
      data: BodyType<SqlPlanOptionRequest>;
      params: PostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdParams;
    }
  > = (props) => {
    const { instanceId, sqlId, data, params } = props ?? {};

    return postV7AltibaseInstanceSqlPlanByInstanceIdAndSqlId(
      instanceId,
      sqlId,
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7AltibaseInstanceSqlPlanByInstanceIdAndSqlId>>
>;
export type PostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdMutationBody =
  BodyType<SqlPlanOptionRequest>;
export type PostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdMutationError = ErrorType<unknown>;

/**
 * @summary 알티베이스 - Plan 조회
 */
export const usePostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7AltibaseInstanceSqlPlanByInstanceIdAndSqlId>>,
      TError,
      {
        instanceId: string;
        sqlId: string;
        data: BodyType<SqlPlanOptionRequest>;
        params: PostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7AltibaseInstanceSqlPlanByInstanceIdAndSqlId>>,
  TError,
  {
    instanceId: string;
    sqlId: string;
    data: BodyType<SqlPlanOptionRequest>;
    params: PostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdParams;
  },
  TContext
> => {
  const mutationOptions =
    getPostV7AltibaseInstanceSqlPlanByInstanceIdAndSqlIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 알티베이스 - SQL 디테일
 */
export const getV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlId = (
  instanceId: MaybeRef<string>,
  sqlId: MaybeRef<string>,
  params: MaybeRef<GetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  sqlId = unref(sqlId);
  params = unref(params);

  return customAxiosInstance<AltiSqlDetailResponse>(
    {
      url: `/api/v7/altibase/instance/${instanceId}/sql/${sqlId}/sql-detail`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdQueryKey = (
  instanceId?: MaybeRef<string>,
  sqlId?: MaybeRef<string>,
  params?: MaybeRef<GetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdParams>,
) => {
  return [
    'api',
    'v7',
    'altibase',
    'instance',
    instanceId,
    'sql',
    sqlId,
    'sql-detail',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  sqlId: MaybeRef<string>,
  params: MaybeRef<GetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdQueryKey(
    instanceId,
    sqlId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlId>>
  > = ({ signal }) =>
    getV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlId(
      instanceId,
      sqlId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(sqlId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlId>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlId>>
>;
export type GetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdQueryError = ErrorType<unknown>;

/**
 * @summary 알티베이스 - SQL 디테일
 */

export function useGetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlId<
  TData = Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  sqlId: MaybeRef<string>,
  params: MaybeRef<GetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseInstanceSqlSqlDetailByInstanceIdAndSqlIdQueryOptions(
    instanceId,
    sqlId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 1) 디테일뷰 SQL 탭에서 사용, 2) 공통 Query Text 전문 팝업
 * @summary (공통) 알티베이스 - QueryText 조회
 */
export const getV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlId = (
  instanceId: MaybeRef<string>,
  sqlId: MaybeRef<string>,
  params?: MaybeRef<GetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  sqlId = unref(sqlId);
  params = unref(params);

  return customAxiosInstance<SqlTextBySqlIdV7Response>(
    {
      url: `/api/v7/altibase/instance/${instanceId}/sql/${sqlId}/sql-text`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdQueryKey = (
  instanceId?: MaybeRef<string>,
  sqlId?: MaybeRef<string>,
  params?: MaybeRef<GetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdParams>,
) => {
  return [
    'api',
    'v7',
    'altibase',
    'instance',
    instanceId,
    'sql',
    sqlId,
    'sql-text',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  sqlId: MaybeRef<string>,
  params?: MaybeRef<GetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdQueryKey(
    instanceId,
    sqlId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlId>>
  > = ({ signal }) =>
    getV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlId(
      instanceId,
      sqlId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(sqlId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlId>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlId>>
>;
export type GetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdQueryError = ErrorType<unknown>;

/**
 * @summary (공통) 알티베이스 - QueryText 조회
 */

export function useGetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlId<
  TData = Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  sqlId: MaybeRef<string>,
  params?: MaybeRef<GetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseInstanceSqlSqlTextByInstanceIdAndSqlIdQueryOptions(
    instanceId,
    sqlId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Altibase Lock 조회
 */
export const getV7AltibaseLock = (
  params: MaybeRef<GetV7AltibaseLockParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<LockListV7Response>(
    { url: `/api/v7/altibase/lock`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7AltibaseLockQueryKey = (params?: MaybeRef<GetV7AltibaseLockParams>) => {
  return ['api', 'v7', 'altibase', 'lock', ...(params ? [params] : [])] as const;
};

export const getGetV7AltibaseLockQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseLock>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseLockParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseLock>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseLockQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7AltibaseLock>>> = ({ signal }) =>
    getV7AltibaseLock(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseLock>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseLockQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseLock>>
>;
export type GetV7AltibaseLockQueryError = ErrorType<unknown>;

/**
 * @summary Altibase Lock 조회
 */

export function useGetV7AltibaseLock<
  TData = Awaited<ReturnType<typeof getV7AltibaseLock>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseLockParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseLock>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseLockQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Altibase Top 10 Memory Table 조회
 */
export const getV7AltibaseMemoryByTable = (
  params: MaybeRef<GetV7AltibaseMemoryByTableParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<MemoryTableV7Response>(
    { url: `/api/v7/altibase/memory-by-table`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7AltibaseMemoryByTableQueryKey = (
  params?: MaybeRef<GetV7AltibaseMemoryByTableParams>,
) => {
  return ['api', 'v7', 'altibase', 'memory-by-table', ...(params ? [params] : [])] as const;
};

export const getGetV7AltibaseMemoryByTableQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseMemoryByTable>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseMemoryByTableParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseMemoryByTable>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseMemoryByTableQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7AltibaseMemoryByTable>>> = ({
    signal,
  }) => getV7AltibaseMemoryByTable(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseMemoryByTable>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseMemoryByTableQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseMemoryByTable>>
>;
export type GetV7AltibaseMemoryByTableQueryError = ErrorType<unknown>;

/**
 * @summary Altibase Top 10 Memory Table 조회
 */

export function useGetV7AltibaseMemoryByTable<
  TData = Awaited<ReturnType<typeof getV7AltibaseMemoryByTable>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseMemoryByTableParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseMemoryByTable>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseMemoryByTableQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Tibero Parameter 조회
 */
export const getV7AltibaseParameterByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ParameterListV7Response>(
    { url: `/api/v7/altibase/parameter/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7AltibaseParameterByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'altibase', 'parameter', instanceId] as const;
};

export const getGetV7AltibaseParameterByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseParameterByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseParameterByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7AltibaseParameterByInstanceId>>> = ({
    signal,
  }) => getV7AltibaseParameterByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseParameterByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseParameterByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseParameterByInstanceId>>
>;
export type GetV7AltibaseParameterByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Tibero Parameter 조회
 */

export function useGetV7AltibaseParameterByInstanceId<
  TData = Awaited<ReturnType<typeof getV7AltibaseParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseParameterByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseParameterByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Altibase 세션 멀티킬
 */
export const postV7AltibaseSessionsKillSessions = (
  multiSessionTargetForm: MaybeRef<MultiSessionTargetForm[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  multiSessionTargetForm = unref(multiSessionTargetForm);

  return customAxiosInstance<MultiSessionKillResponse>(
    {
      url: `/api/v7/altibase/sessions/kill-sessions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: multiSessionTargetForm,
      signal,
    },
    options,
  );
};

export const getPostV7AltibaseSessionsKillSessionsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessions>>,
    TError,
    { data: BodyType<MultiSessionTargetForm[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessions>>,
  TError,
  { data: BodyType<MultiSessionTargetForm[]> },
  TContext
> => {
  const mutationKey = ['postV7AltibaseSessionsKillSessions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessions>>,
    { data: BodyType<MultiSessionTargetForm[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7AltibaseSessionsKillSessions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7AltibaseSessionsKillSessionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessions>>
>;
export type PostV7AltibaseSessionsKillSessionsMutationBody = BodyType<MultiSessionTargetForm[]>;
export type PostV7AltibaseSessionsKillSessionsMutationError = ErrorType<unknown>;

/**
 * @summary Altibase 세션 멀티킬
 */
export const usePostV7AltibaseSessionsKillSessions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessions>>,
      TError,
      { data: BodyType<MultiSessionTargetForm[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessions>>,
  TError,
  { data: BodyType<MultiSessionTargetForm[]> },
  TContext
> => {
  const mutationOptions = getPostV7AltibaseSessionsKillSessionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary [Altibase] SQL 디테일 - 추이 탭
 */
export const getV7AltibaseSqlByInterval = (
  params: MaybeRef<GetV7AltibaseSqlByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlIntervalV7Response>(
    { url: `/api/v7/altibase/sql-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7AltibaseSqlByIntervalQueryKey = (
  params?: MaybeRef<GetV7AltibaseSqlByIntervalParams>,
) => {
  return ['api', 'v7', 'altibase', 'sql-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7AltibaseSqlByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseSqlByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7AltibaseSqlByInterval>>> = ({
    signal,
  }) => getV7AltibaseSqlByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseSqlByInterval>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseSqlByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseSqlByInterval>>
>;
export type GetV7AltibaseSqlByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary [Altibase] SQL 디테일 - 추이 탭
 */

export function useGetV7AltibaseSqlByInterval<
  TData = Awaited<ReturnType<typeof getV7AltibaseSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseSqlByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 알티베이스 > 인스턴스 디테일: SQL 목록 탭
 */
export const getV7AltibaseSqlList = (
  params: MaybeRef<GetV7AltibaseSqlListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlListV7Response>(
    { url: `/api/v7/altibase/sql-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7AltibaseSqlListQueryKey = (params?: MaybeRef<GetV7AltibaseSqlListParams>) => {
  return ['api', 'v7', 'altibase', 'sql-list', ...(params ? [params] : [])] as const;
};

export const getGetV7AltibaseSqlListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseSqlList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseSqlListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseSqlList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseSqlListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7AltibaseSqlList>>> = ({ signal }) =>
    getV7AltibaseSqlList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseSqlList>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseSqlListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseSqlList>>
>;
export type GetV7AltibaseSqlListQueryError = ErrorType<unknown>;

/**
 * @summary 알티베이스 > 인스턴스 디테일: SQL 목록 탭
 */

export function useGetV7AltibaseSqlList<
  TData = Awaited<ReturnType<typeof getV7AltibaseSqlList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseSqlListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseSqlList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseSqlListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Altibase] SQL 디테일 - 과거 이력 탭
 */
export const getV7AltibaseSqlListByInterval = (
  params: MaybeRef<GetV7AltibaseSqlListByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlListByIntervalV7Response>(
    { url: `/api/v7/altibase/sql-list-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7AltibaseSqlListByIntervalQueryKey = (
  params?: MaybeRef<GetV7AltibaseSqlListByIntervalParams>,
) => {
  return ['api', 'v7', 'altibase', 'sql-list-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7AltibaseSqlListByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseSqlListByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseSqlListByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseSqlListByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseSqlListByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7AltibaseSqlListByInterval>>> = ({
    signal,
  }) => getV7AltibaseSqlListByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseSqlListByInterval>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseSqlListByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseSqlListByInterval>>
>;
export type GetV7AltibaseSqlListByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary [Altibase] SQL 디테일 - 과거 이력 탭
 */

export function useGetV7AltibaseSqlListByInterval<
  TData = Awaited<ReturnType<typeof getV7AltibaseSqlListByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7AltibaseSqlListByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7AltibaseSqlListByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseSqlListByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Altibase Memory Module 목록 조회
 */
export const getV7AltibaseMemoryModuleByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<MemoryModuleResponse>(
    { url: `/api/v7/altibase/${instanceId}/memory-module`, method: 'GET', signal },
    options,
  );
};

export const getGetV7AltibaseMemoryModuleByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'altibase', instanceId, 'memory-module'] as const;
};

export const getGetV7AltibaseMemoryModuleByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseMemoryModuleByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseMemoryModuleByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseMemoryModuleByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7AltibaseMemoryModuleByInstanceId>>
  > = ({ signal }) => getV7AltibaseMemoryModuleByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseMemoryModuleByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseMemoryModuleByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseMemoryModuleByInstanceId>>
>;
export type GetV7AltibaseMemoryModuleByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Altibase Memory Module 목록 조회
 */

export function useGetV7AltibaseMemoryModuleByInstanceId<
  TData = Awaited<ReturnType<typeof getV7AltibaseMemoryModuleByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseMemoryModuleByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseMemoryModuleByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Altibase - 파라미터 디테일 (Information과 History 분리)
 */
export const getV7AltibaseParameterDetailByInstanceIdAndParameterName = (
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7AltibaseParameterDetailByInstanceIdAndParameterNameParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  parameterName = unref(parameterName);
  params = unref(params);

  return customAxiosInstance<ApiResponseAltibaseParameterDetailResponse>(
    {
      url: `/api/v7/altibase/${instanceId}/parameter/${parameterName}/detail`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7AltibaseParameterDetailByInstanceIdAndParameterNameQueryKey = (
  instanceId?: MaybeRef<string>,
  parameterName?: MaybeRef<string>,
  params?: MaybeRef<GetV7AltibaseParameterDetailByInstanceIdAndParameterNameParams>,
) => {
  return [
    'api',
    'v7',
    'altibase',
    instanceId,
    'parameter',
    parameterName,
    'detail',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7AltibaseParameterDetailByInstanceIdAndParameterNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7AltibaseParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseParameterDetailByInstanceIdAndParameterNameQueryKey(
    instanceId,
    parameterName,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7AltibaseParameterDetailByInstanceIdAndParameterName>>
  > = ({ signal }) =>
    getV7AltibaseParameterDetailByInstanceIdAndParameterName(
      instanceId,
      parameterName,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(parameterName))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseParameterDetailByInstanceIdAndParameterName>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseParameterDetailByInstanceIdAndParameterNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseParameterDetailByInstanceIdAndParameterName>>
>;
export type GetV7AltibaseParameterDetailByInstanceIdAndParameterNameQueryError = ErrorType<unknown>;

/**
 * @summary Altibase - 파라미터 디테일 (Information과 History 분리)
 */

export function useGetV7AltibaseParameterDetailByInstanceIdAndParameterName<
  TData = Awaited<ReturnType<typeof getV7AltibaseParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7AltibaseParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseParameterDetailByInstanceIdAndParameterNameQueryOptions(
    instanceId,
    parameterName,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Replication Info 조회
 */
export const getV7AltibaseReplicationInfoByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7AltibaseReplicationInfoByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ReplicationInfoV7Response>(
    {
      url: `/api/v7/altibase/${instanceId}/replication-info`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7AltibaseReplicationInfoByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7AltibaseReplicationInfoByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'altibase',
    instanceId,
    'replication-info',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7AltibaseReplicationInfoByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseReplicationInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7AltibaseReplicationInfoByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseReplicationInfoByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseReplicationInfoByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7AltibaseReplicationInfoByInstanceId>>
  > = ({ signal }) =>
    getV7AltibaseReplicationInfoByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseReplicationInfoByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseReplicationInfoByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseReplicationInfoByInstanceId>>
>;
export type GetV7AltibaseReplicationInfoByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Replication Info 조회
 */

export function useGetV7AltibaseReplicationInfoByInstanceId<
  TData = Awaited<ReturnType<typeof getV7AltibaseReplicationInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7AltibaseReplicationInfoByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseReplicationInfoByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseReplicationInfoByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Altibase Replications 조회
 */
export const getV7AltibaseReplicationsByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ReplicationV7Response>(
    { url: `/api/v7/altibase/${instanceId}/replications`, method: 'GET', signal },
    options,
  );
};

export const getGetV7AltibaseReplicationsByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'altibase', instanceId, 'replications'] as const;
};

export const getGetV7AltibaseReplicationsByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AltibaseReplicationsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseReplicationsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseReplicationsByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7AltibaseReplicationsByInstanceId>>
  > = ({ signal }) => getV7AltibaseReplicationsByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseReplicationsByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseReplicationsByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7AltibaseReplicationsByInstanceId>>
>;
export type GetV7AltibaseReplicationsByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Altibase Replications 조회
 */

export function useGetV7AltibaseReplicationsByInstanceId<
  TData = Awaited<ReturnType<typeof getV7AltibaseReplicationsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7AltibaseReplicationsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AltibaseReplicationsByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Altibase Session 디테일 정보 조회
 */
export const getV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPid = (
  instanceId: MaybeRef<string>,
  clientPid: MaybeRef<number>,
  params?: MaybeRef<GetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidParams>,
  sessionId: MaybeRef<number> = 19470,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  clientPid = unref(clientPid);
  params = unref(params);
  sessionId = unref(sessionId);

  return customAxiosInstance<ApiResponseSessionDetailV7Response>(
    {
      url: `/api/v7/altibase/${instanceId}/session/${sessionId}/clientPid/${clientPid}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidQueryKey = (
  instanceId?: MaybeRef<string>,
  clientPid?: MaybeRef<number>,
  params?: MaybeRef<GetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidParams>,
  sessionId: MaybeRef<number> = 19470,
) => {
  return [
    'api',
    'v7',
    'altibase',
    instanceId,
    'session',
    sessionId,
    'clientPid',
    clientPid,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPid>
  >,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  clientPid: MaybeRef<number>,
  params?: MaybeRef<GetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidParams>,
  sessionId: MaybeRef<number> = 19470,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPid>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidQueryKey(
    instanceId,
    clientPid,
    params,
    sessionId,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPid>>
  > = ({ signal }) =>
    getV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPid(
      instanceId,
      clientPid,
      params,
      sessionId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(sessionId) && unref(clientPid))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPid>>,
    TError,
    TData
  >;
};

export type GetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPid>>
  >;
export type GetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidQueryError =
  ErrorType<unknown>;

/**
 * @summary Altibase Session 디테일 정보 조회
 */

export function useGetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPid<
  TData = Awaited<
    ReturnType<typeof getV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPid>
  >,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  clientPid: MaybeRef<number>,
  params?: MaybeRef<GetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidParams>,
  sessionId: MaybeRef<number> = 19470,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPid>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions =
    getGetV7AltibaseSessionClientPidByInstanceIdAndSessionIdAndClientPidQueryOptions(
      instanceId,
      clientPid,
      params,
      sessionId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Altibase 세션 강제 종료
 */
export const postV7AltibaseSessionsKillSessionByInstanceId = (
  params: MaybeRef<PostV7AltibaseSessionsKillSessionByInstanceIdParams>,
  instanceId: MaybeRef<string> = '5b81987c-9192-4516-ab70-87c235923445',
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);
  instanceId = unref(instanceId);

  return customAxiosInstance<MultiSessionKillResponse>(
    {
      url: `/api/v7/altibase/${instanceId}/sessions/kill-session`,
      method: 'POST',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7AltibaseSessionsKillSessionByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessionByInstanceId>>,
    TError,
    { params: PostV7AltibaseSessionsKillSessionByInstanceIdParams; instanceId?: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessionByInstanceId>>,
  TError,
  { params: PostV7AltibaseSessionsKillSessionByInstanceIdParams; instanceId?: string },
  TContext
> => {
  const mutationKey = ['postV7AltibaseSessionsKillSessionByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessionByInstanceId>>,
    { params: PostV7AltibaseSessionsKillSessionByInstanceIdParams; instanceId?: string }
  > = (props) => {
    const { params, instanceId } = props ?? {};

    return postV7AltibaseSessionsKillSessionByInstanceId(params, instanceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7AltibaseSessionsKillSessionByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessionByInstanceId>>
>;

export type PostV7AltibaseSessionsKillSessionByInstanceIdMutationError = ErrorType<unknown>;

/**
 * @summary Altibase 세션 강제 종료
 */
export const usePostV7AltibaseSessionsKillSessionByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessionByInstanceId>>,
      TError,
      { params: PostV7AltibaseSessionsKillSessionByInstanceIdParams; instanceId?: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7AltibaseSessionsKillSessionByInstanceId>>,
  TError,
  { params: PostV7AltibaseSessionsKillSessionByInstanceIdParams; instanceId?: string },
  TContext
> => {
  const mutationOptions = getPostV7AltibaseSessionsKillSessionByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
